import { setAccessToken } from "./cookieHelper";
import { withIronSessionApiRoute } from "iron-session/next";
import { sessionOptions } from "./session";

const mockLogin = withIronSessionApiRoute(async (req, res) => {
  try {
    const url = process.env.NEXT_PUBLIC_API_URL + "/access/login";
    const response: any = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: "email",
        value: "rajesh+6@betalectic.com",
        password: "1234567890",
      }),
    });

    console.log("response", response);

    const data = await response.json();
    res.setHeader("Set-Cookie", [setAccessToken(data["access_token"])]);
    req.session.token = data;
    res.send(JSON.stringify(data));
  } catch (error) {
    console.log("error in nextjs", error);
    return res.status(422).json(error);
  }
}, sessionOptions);

export { mockLogin };
